
<script>
	import { hslide } from '../../../utils/hslide';
  import SlideContent from './SlideContent.svelte';
  import { csv, json} from 'd3-fetch';
  import { __,__c } from '../../../utils/i18n';
	
	export let title;
	export let subtitle;
	export let level;
	export let topHed;

	const slidesURL = window.DATA_URLS.slides

	async function readCSV(l) {
		const slidesCSV = await csv(slidesURL);
		let result = slidesCSV.reduce(function (r, a) {
			r[a.zone] = r[a.zone] || [];
			r[a.zone].push(a);
			return r;
		}, Object.create(null));
		return result[l]
	}

  
	let direction;


	let info = readCSV(level);

	function handler(event) {
    direction = event.detail.direction;

    direction=="left"?next():prev()
  }

	const scrollY = document.body.style.top;

	let show = false;
	
	const start=()=>{

		show = !show;
	}	
	
	function handleShow() {
		show = !show; 
	}

</script>

<!-- 
	on:keypress={(e)=>{if (e.key == "Enter") startSlideshow(e) }}
	on:keypress={(e)=>{if (e.key == "Enter") startSlideshowStopScroll(e) }}
-->

<div class="playbox">
	<div class="interactive" 
		on:click={handleShow}  
		on:keypress={(e)=>{if (e.key == "Enter") handleShow()}}
		role="button" 
		tabindex="0"
    aria-label="{title}{subtitle}. {__('Select button to open slideshow.')}"
	>
		<h3>{title}</h3>
		<svg class="play">
			<use xlink:href="#play-icon" />
		</svg>
		<h4>{subtitle}</h4>
	</div>
</div>

{#if show}
	{#await info}
	<p></p>
	{:then i}
	<SlideContent 
		on:show={handleShow}
		{topHed}
		slides = {i}
		{level}
		/>
	{/await}
{/if}
